import {
  SET_SCHOOLS
} from './mutationTypes'

export const mutations = {
  [SET_SCHOOLS]: (state, payload) => state.schools = payload
}
